(function () {
    'use strict';

    angular
        .module('elogbooks.admin.users')
        .controller('UserSiteAccessController', UserSiteAccessController);

    function UserSiteAccessController(
        $state,
        apiClient,
        messenger,
        lodash,
        userResponse,
        membershipsResponse,
        validationService,
        $scope,
        userManager
    ) {
        var vm = this;
        vm.canViewSiteDetails = userManager.hasPermission(['user_permission_view_sites', 'user_permission_client_admin_manage_sites']);
        vm.delete = deleteMembership;
        vm.removeSelected = removeSelected;
        vm.search = searchMemberships;
        vm.toggleHeader = toggleHeader;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        vm.toggleRow = toggleRow;
        vm.user = userResponse;
        vm.memberships = membershipsResponse;
        vm.searchQuery = $state.params.name || '';
        vm.searchResults = vm.memberships;
        vm.isFiltered = vm.searchQuery.length > 0;
        vm.validationService = validationService;
        vm.form = null;
        vm.dirtyFormControll = null;
        vm.selectedMemberships = [];
        vm.selectedCount = 0;
        vm.allSelected = false;
        vm.isRemovingSelected = false;

        initializeSelectionState();

        vm.setForm = (form) => {
            vm.form = form;
            let findController = (scope) =>
                scope.hasOwnProperty('vm') ? scope.vm :
                    (scope.hasOwnProperty('$parent') ? findController(scope.$parent) : null);

            let controller = findController($scope.$parent);
            if (controller && controller.formControll) {
                vm.dirtyFormControll = controller.formControll;
                vm.dirtyFormControll.setForm(form);
            }
        }

        function searchMemberships() {
            $state.go('.', { name: vm.searchQuery, sitesPage: 1 })
        }

        function initializeSelectionState() {
            vm.selectedMemberships = [];
            vm.selectedCount = 0;
            vm.allSelected = false;

            lodash.each(vm.searchResults.memberships, function (membership) {
                membership.checked = false;
            });

            updateHeaderCheckboxState();
        }

        function toggleAll(allSelected) {
            vm.selectedMemberships = [];

            lodash.each(vm.searchResults.memberships, function (membership) {
                membership.checked = allSelected;

                if (allSelected) {
                    vm.selectedMemberships.push(membership);
                }
            });

            vm.selectedCount = vm.selectedMemberships.length;
            updateHeaderCheckboxState();
        }

        function toggleHeader() {
            vm.allSelected = !vm.allSelected;
            toggleAll(vm.allSelected);
        }

        function toggleOne(membership) {
            if (membership.checked) {
                if (!lodash.includes(vm.selectedMemberships, membership)) {
                    vm.selectedMemberships.push(membership);
                }
            } else {
                vm.selectedMemberships = lodash.without(vm.selectedMemberships, membership);
            }

            vm.selectedCount = vm.selectedMemberships.length;
            updateHeaderCheckboxState();
        }

        function toggleRow(membership) {
            membership.checked = !membership.checked;
            toggleOne(membership);
        }

        function updateHeaderCheckboxState() {
            var total = vm.searchResults.memberships.length;
            var headerCheckbox = document.getElementById('site-access-select-all');

            vm.allSelected = total > 0 && vm.selectedCount === total;

            if (headerCheckbox) {
                headerCheckbox.indeterminate = vm.selectedCount > 0 && vm.selectedCount < total;
            }
        }

        function deleteMembership(membership) {
            vm.dirtyFormControll && vm.dirtyFormControll.setFormDirty();

            apiClient.delete(membership._links.delete.href).then(function (response) {
                vm.dirtyFormControll && vm.dirtyFormControll.setFormNotDirty();

                if (response) {
                    $state.go('.', {}, {reload: true});
                } else {
                    messenger.error('DELETE_REQUEST_ERROR');
                }
            });
        }

        function removeSelected() {
            if (vm.selectedCount === 0 || vm.isRemovingSelected) {
                return;
            }

            if (!vm.memberships.getLink('delete-selected-memberships')) {
                messenger.error('DELETE_REQUEST_ERROR');
                return;
            }

            vm.isRemovingSelected = true;
            vm.dirtyFormControll && vm.dirtyFormControll.setFormDirty();

            apiClient.create(vm.memberships.getLink('delete-selected-memberships'), {
                _links: {
                    membership: vm.selectedMemberships.map(function (membership) {
                        return {
                            href: membership._links.self.href
                        };
                    })
                }
            }).then(function (response) {
                vm.isRemovingSelected = false;
                vm.dirtyFormControll && vm.dirtyFormControll.setFormNotDirty();

                if (response) {
                    $state.go('.', {}, {reload: true}).then(function () {
                        messenger.success('SITE_ACCESS_REMOVED');
                    });
                } else {
                    messenger.error('DELETE_REQUEST_ERROR');
                }
            }, function () {
                vm.isRemovingSelected = false;
                vm.dirtyFormControll && vm.dirtyFormControll.setFormNotDirty();
                messenger.error('DELETE_REQUEST_ERROR');
            });
        }
    }
})();
